module.exports = __webpack_public_path__ + "img/function-10.8d7ee0a7.png";